import "core-js/modules/es.array.index-of.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList } from "@/api/PMS/communityPartyBuilding/activityManage";
import waves from "@/directive/waves"; // 水波纹指令

import activeAdd from "../activityApply/add";
export default {
  name: "ComplexTable",
  components: {
    activeAdd: activeAdd
  },
  directives: {
    waves: waves
  },
  props: {
    isDashboard: Boolean
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        activityAuditStatus: "1"
      },
      title: "",
      receiverObjectType: "",
      id: -1,
      dates: [],
      isDetail: false,
      // 是否是查看
      isAudit: false,
      // 是否是审核
      multipleSelection: [],
      dialogFormVisible: false,
      dialogFormViewListVisible: false,
      dialogFormDetailVisible: false,
      dialogActiveFormVisible: false
    };
  },
  computed: {
    isBuildParty: function isBuildParty() {
      return this.$route.path.indexOf("partyactivityManage") > -1;
    }
  },
  created: function created() {
    // 获取路由的配置
    var appType = this.$route.query.appType;

    if (appType !== undefined) {
      this.listQuery.appType = parseInt(appType);
    }

    this.getList();
  },
  methods: {
    getNoticeTypeName: function getNoticeTypeName(val) {
      switch (val) {
        case 0:
          return "全体成员";

        case 1:
          return "全体物业";

        case 2:
          return "全体业主";

        case 3:
          return "全体租户";
      }
    },
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogActiveFormVisible = false;
      this.dialogFormVisible = false;
    },
    handDetailCancle: function handDetailCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormDetailVisible = false;
    },
    handViewListCancle: function handViewListCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormViewListVisible = false;
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;

      if (this.dates !== null && this.dates.length > 0) {
        this.listQuery.beginDate = this.dates[0];
        this.listQuery.endDate = this.dates[1];
      } else {
        this.listQuery.beginDate = "";
        this.listQuery.endDate = "";
      } // if (this.isBuildParty || this.isDashboard) {
      //   this.listQuery.appType = 0
      // } else {
      //   this.listQuery.appType = 1
      // }


      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    isActiveOver: function isActiveOver(activeTime) {
      var overTime = new Date(activeTime).getTime() + 16 * 3600 * 1000; // 活动结束时间

      if (activeTime && new Date().getTime() > overTime) {
        return true;
      } else {
        return false;
      }
    },
    handleCheck: function handleCheck(id) {
      this.isAudit = false;
      this.isDetail = true;
      this.id = id;
      this.title = "查看";
      this.dialogFormVisible = true;
    },
    handleExamine: function handleExamine(id) {
      this.isAudit = true;
      this.isDetail = true;
      this.id = id;
      this.title = "审核";
      this.dialogFormVisible = true;
    }
  }
};